import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  boxContainerScrollable: {
    maxHeight: 450,
    overflowY: 'auto',
  },
  boxContainer: {
    maxHeight: 'fit-content',
  },
}));

export default useStyles;
